/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Secretary
 */
export interface Secretary {
    /**
     * 
     * @type {string}
     * @memberof Secretary
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Secretary
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Secretary
     */
    phoneNumber?: string;
}

/**
 * Check if a given object implements the Secretary interface.
 */
export function instanceOfSecretary(value: object): boolean {
    return true;
}

export function SecretaryFromJSON(json: any): Secretary {
    return SecretaryFromJSONTyped(json, false);
}

export function SecretaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Secretary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'phoneNumber': json['phone_number'] == null ? undefined : json['phone_number'],
    };
}

export function SecretaryToJSON(value?: Secretary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'phone_number': value['phoneNumber'],
    };
}

